import { render, staticRenderFns } from "./CotacoesMarketplaceDetalhes.vue?vue&type=template&id=9bbacbf4"
import script from "./CotacoesMarketplaceDetalhes.vue?vue&type=script&lang=js"
export * from "./CotacoesMarketplaceDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports